import React, { useState, useMemo, useEffect, useCallback } from 'react'; // Importa useCallback
import { 
  ArrowLeft, Phone, Mail, Calendar, MapPin, User, Users, Clock, BookOpen, 
  DollarSign, TrendingUp, CheckCircle, XCircle, AlertCircle, 
  FileText, Star, Award, Eye, MessageCircle, Filter, Search
} from 'lucide-react';
import { useParams } from 'react-router-dom';
import useClientesModel from '../../../modelos/Clientes/modeloClientes';
import EditableField from '../../../components/EditableFields';
import { useSolicitudesDisponiblesModel } from '../../../modelos/Solicitudes/modeloSolicitudes';
import { useContabilidadModel } from '../../../modelos/Contabilidad/modeloContabilidad';
import CardSolicitud from '../../../views/compartedRoutes/solicitudes/CardSolicitud';
import CardServicio from '../../../views/compartedRoutes/Contabilidad/cardServicio';
import { useListasModel } from '../../../modelos/listas/modeloListas';
import { useFormOptions } from '../../../config/constants';
import BooleanField from '../../../components/BooleanField';
import { obtenerNombreEmpresaReal } from '../../../config/unificacion';
import AddCuentasCliente from './ModuloClientes/AddCuentaCliente';

const HistorialCliente = ({}) => {
  const {nombreEmpresa, numeroCliente } = useParams();
  let nombreEmpresaReal = obtenerNombreEmpresaReal(nombreEmpresa);
  const {cliente,loadingClientes,getCliente,setupWebSocketsClientes,updateCliente,
    cargarListaCampanas,
    listCampanasOptions,
    eliminaCuentaCliente,
  } = useClientesModel();
  const {solicitudesPorCliente,cargarSolicitudesDeCliente} = useSolicitudesDisponiblesModel();
  const {serviciosPorClientes,getServiciosPorCliente} = useContabilidadModel();

  //listas
  const {
      carrerasOptions,
      cargarCarreras,
      universidadesOptions,
      cargarUniversidades,
  } = useListasModel();
  const {
      procedenciaUsuarioListOptions,
  } = useFormOptions();

  //cargar cliente -- toca meter salas
  useEffect(() => {
    if (!nombreEmpresaReal || !numeroCliente) return;
    
    let socketCleanup = null;
    
    const cargarCliente = async () => {
        try {
            // Cargar el cliente desde la API
            const clienteObjeto = await getCliente(nombreEmpresaReal, numeroCliente);
            
            // Si se cargó correctamente, configurar el socket
            if (clienteObjeto) {
                socketCleanup = setupWebSocketsClientes(clienteObjeto, nombreEmpresaReal);
            }
        } catch (error) {
            console.error('Error al cargar cliente:', error);
        }
    };
    
    cargarCliente();
    
    // Cleanup function
    return () => {
        if (socketCleanup) {
            socketCleanup();
        }
    };
    
}, [nombreEmpresaReal, numeroCliente]);

  //cargar solicitudes
  useEffect(() =>{
    cargarSolicitudesDeCliente(nombreEmpresaReal,numeroCliente);
  },[]);

  //cargando servicios
  useEffect(() =>{
    console.log("a cargar servicios");
    getServiciosPorCliente(nombreEmpresaReal,numeroCliente);
  },[]);

  //guardar update
  const handleSave = async(field, value) =>{

    console.log("update",field,value);

    updateCliente(cliente.numero,nombreEmpresaReal,field,value,'field');

  }

  //cargar carrera, cargar universidad
  useEffect(() =>{
    cargarCarreras();
    cargarUniversidades();
  },[]);

  //cargar procedencia
  useEffect(() =>{
    cargarListaCampanas();
  },[])

  //SEARCH Y DEMAS COSAS
  const [searchSolicitudes, setSearchSolicitudes] = useState('');
  const [searchServicios, setSearchServicios] = useState('');
  const [filtroSolicitudes, setFiltroSolicitudes] = useState('todas');
  const [filtroServicios, setFiltroServicios] = useState('todos');

  // Calcular estadísticas
  const estadisticas = useMemo(() => {
    const totalServicios = serviciosPorClientes.length;
    const totalSolicitudes = solicitudesPorCliente.length;
    const totalGastado = serviciosPorClientes.reduce((sum, servicio) => sum + (servicio.preciocobrado || 0), 0);
    const totalGanancia = serviciosPorClientes.reduce((sum, servicio) => sum + (servicio.preciocobrado - servicio.preciotutor || 0), 0);
    const serviciosCompletados = serviciosPorClientes.filter(s => s.getTrabajoEntregado()).length;
    const solicitudesPendientes = solicitudesPorCliente.filter(s => s.Estado === 'DISPONIBLE').length;
    
    return {
      totalServicios,
      totalSolicitudes,
      totalGastado,
      totalGanancia,
      serviciosCompletados,
      solicitudesPendientes,
      promedioGasto: totalServicios > 0 ? totalGastado / totalServicios : 0,
      tasaConversion: totalSolicitudes > 0 ? (totalServicios / totalSolicitudes) * 100 : 0
    };
  }, [serviciosPorClientes, solicitudesPorCliente]);

  // Filtrar solicitudes
  const solicitudesFiltradas = useMemo(() => {
    let filtradas = [...solicitudesPorCliente];
    
    // Filtrar por estado
    if (filtroSolicitudes === 'pendientes') {
      filtradas = filtradas.filter(s => s.Estado === 'DISPONIBLE');
    } else if (filtroSolicitudes === 'completadas') {
      filtradas = filtradas.filter(s => s.Estado !== 'DISPONIBLE');
    }
    
    // Filtrar por búsqueda
    if (searchSolicitudes) {
      filtradas = filtradas.filter(solicitud => 
        solicitud.materia.toLowerCase().includes(searchSolicitudes.toLowerCase()) ||
        solicitud.id.toString().includes(searchSolicitudes)
      );
    }
    
    // Ordenar por fecha
    filtradas.sort((a, b) => new Date(b.fechasistema) - new Date(a.fechasistema));
    
    return filtradas;
  }, [solicitudesPorCliente, filtroSolicitudes, searchSolicitudes]);

  // Filtrar servicios
  const serviciosFiltrados = useMemo(() => {
    let filtrados = [...serviciosPorClientes];
    
    // Filtrar por estado
    if (filtroServicios === 'completados') {
      filtrados = filtrados.filter(s => s.getTrabajoEntregado());
    } else if (filtroServicios === 'proceso') {
      filtrados = filtrados.filter(s => !s.getTrabajoEntregado());
    }
    
    // Filtrar por búsqueda
    if (searchServicios) {
      filtrados = filtrados.filter(servicio => 
        servicio.materia.toLowerCase().includes(searchServicios.toLowerCase()) ||
        servicio.codigo.toLowerCase().includes(searchServicios.toLowerCase())
      );
    }
    
    // Ordenar por fecha
    filtrados.sort((a, b) => new Date(b.fechasistema) - new Date(a.fechasistema));
    
    return filtrados;
  }, [serviciosPorClientes, filtroServicios, searchServicios]);

  const StatCard = ({ title, value, subtitle, icon: Icon, color = 'blue' }) => (
    <div className={`bg-${color}-50 p-4 rounded-xl border border-${color}-100`}>
      <div className="flex items-center gap-3">
        <div className={`p-2 bg-${color}-100 rounded-lg`}>
          <Icon className={`w-5 h-5 text-${color}-600`} />
        </div>
        <div>
          <p className={`text-2xl font-bold text-${color}-700`}>{value}</p>
          <p className="text-sm text-gray-600">{title}</p>
          {subtitle && <p className="text-xs text-gray-500">{subtitle}</p>}
        </div>
      </div>
    </div>
  );

  const handleAgregarCuenta = useCallback((cuentaData) => {
    console.log("Nueva cuenta recibida desde el componente hijo:", cuentaData);

    updateCliente(cliente.numero,nombreEmpresaReal,'cuentasClientes',cuentaData,'array_insert');

  }, [cliente, nombreEmpresaReal]);

  const eliminarCuenta = async(cuentaData) => {
    console.log("eliminar cuenta",cuentaData);

    await eliminaCuentaCliente(nombreEmpresa,cliente.numero,cuentaData);
  }

  if(loadingClientes){
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-center">
          <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-blue-500 border-r-transparent"></div>
          <p className="mt-2 text-gray-600">Cargando clientes...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50">
      
      {/* Header */}
      <div className="bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <button 
                onClick={() => window.history.back()}
                className="p-2 hover:bg-gray-100 rounded-full transition-colors"
              >
                <ArrowLeft className="w-5 h-5 text-gray-600" />
              </button>
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center text-white font-bold">
                  {cliente?.nombreCliente?.charAt(0)?.toUpperCase() || 'C'}
                </div>
                <div>
                  <h1 className="text-xl font-bold text-gray-900">{cliente?.nombreCliente || 'Cliente'}</h1>
                  <p className="text-gray-600 text-sm">{cliente?.numero || numeroCliente}</p>
                  <p className="text-gray-500 text-sm">{cliente?.Universidadd}</p>
                </div>
              </div>
            </div>
            <div className="text-right">
              <p className="text-sm text-gray-500">Historial completo</p>
              <p className="text-xs text-gray-400">Número: {numeroCliente}</p>
            </div>
          </div>
        </div>
      </div>

      {/* Info de cliente mejorada */}
      <div className="max-w-7xl mx-auto px-6 py-6">
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-6">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center">
              <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
            </div>
            <h2 className="text-lg font-bold text-gray-900">Información del Cliente</h2>
          </div>

          {/* Grid principal de información */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            
            {/* Información Personal */}
            <div className="space-y-4">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-1 h-6 bg-blue-500 rounded-full"></div>
                <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wide">
                  Información Personal
                </h3>
              </div>
              
              <div className="space-y-4 pl-3">
                <EditableField
                  field="nombreCliente"
                  label="Nombre WhatsApp Cliente"
                  value={cliente.nombreCliente}
                  type="field"
                  isAdmin={true}
                  onSave={handleSave}
                />

                <EditableField
                  field="nombrecompletoCliente"
                  label="Nombre Completo"
                  value={cliente.nombrecompletoCliente}
                  type="field"
                  isAdmin={true}
                  onSave={handleSave}
                />

                <EditableField
                  field="numero"
                  label="Número de WhatsApp"
                  value={cliente.numero}
                  type="field"
                  isAdmin={false}
                />

                <EditableField
                  field="fechaContacto"
                  label="Fecha de Contacto"
                  value={cliente.fechaContacto}
                  type="datetime"
                  isAdmin={false}
                />

                <EditableField
                  field="nombre"
                  label="Nombre"
                  value={cliente.nombre}
                  type="field"
                  isAdmin={true}
                  onSave={handleSave}
                />

                <EditableField
                  field="apellido"
                  label="Apellido"
                  value={cliente.apellido}
                  type="field"
                  isAdmin={true}
                  onSave={handleSave}
                />

                <EditableField
                  field="correoElectronico"
                  label="Correo electronico"
                  value={cliente.correoElectronico}
                  type="field"
                  isAdmin={true}
                  onSave={handleSave}
                />

              </div>
            </div>

            {/* Información Académica */}
            <div className="space-y-4">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-1 h-6 bg-green-500 rounded-full"></div>
                <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wide">
                  Información Académica
                </h3>
              </div>
              
              <div className="space-y-4 pl-3">
                <EditableField
                  field="Carrera"
                  label="Carrera"
                  value={cliente.carrera}
                  type="react-select"
                  options={carrerasOptions}
                  isAdmin={true}
                  onSave={handleSave}
                />

                <EditableField
                  field="Universidadd"
                  label="Universidad"
                  value={cliente.universidad}
                  type="react-select"
                  options={universidadesOptions}
                  isAdmin={true}
                  onSave={handleSave}
                />

                <EditableField
                  field="procedencia"
                  label="Procedencia"
                  value={cliente.procedencia}
                  type="react-select"
                  options={procedenciaUsuarioListOptions}
                  isAdmin={true}
                  onSave={handleSave}
                />

                {/* Campaña Realizada - solo si procedencia es "CAMPAÑA INSTAGRAM" */}
                {cliente.procedencia === "CAMPAÑA INSTAGRAM" && (
                  <div className="bg-amber-50 border border-amber-200 rounded-lg p-3">
                    <EditableField
                      field="campanaRealizada"
                      label="Campaña Realizada"
                      value={cliente.campanaRealizada}
                      type="react-select"
                      options={listCampanasOptions}
                      isAdmin={true}
                      onSave={handleSave}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Información Adicional */}
          <div className="mt-8 pt-6 border-t border-gray-200">
            <div className="flex items-center gap-2 mb-6">
              <div className="w-1 h-6 bg-purple-500 rounded-full"></div>
              <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wide">
                Información Adicional
              </h3>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 pl-3">
              {/* Notas y Configuraciones */}
              <div className="space-y-4">
                <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
                  <EditableField
                    field="contextoCliente"
                    label="Notas del cliente"
                    value={cliente.contextoCliente}
                    type="text"
                    isAdmin={true}
                    onSave={handleSave}
                  />
                </div>

                <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                  <BooleanField
                    field="permitidoNotificacionesWachat"
                    label="Notificaciones Permitidas"
                    value={cliente.permitidoNotificacionesWachat}
                    isAdmin={true}
                    onSave={handleSave}
                  />
                </div>
              </div>

              {/* Cliente UNAD y Configuración de Plataforma */}
              <div className="space-y-4">
                <div className="bg-emerald-50 border border-emerald-200 rounded-lg p-4">
                  <BooleanField
                    field="clienteEspecialPlataformaUNAD"
                    label="Cliente de plataforma"
                    value={cliente.clienteEspecialPlataformaUNAD}
                    isAdmin={true}
                    onSave={handleSave}
                  />
                </div>

                {/* Información de Plataforma - Solo visible si es cliente UNAD */}
                {cliente.clienteEspecialPlataformaUNAD && (
                  <div className="bg-orange-50 border border-orange-200 rounded-lg p-4 space-y-4">
                    <div className="flex items-center gap-2 mb-3">
                      <svg className="w-4 h-4 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      <h4 className="text-sm font-semibold text-orange-800">Acceso a Plataforma UNAD</h4>
                    </div>
                    
                    <EditableField
                      field="infoPlataforma.plataforma"
                      label="Plataforma del cliente"
                      value={cliente.infoPlataforma?.plataforma || ''}
                      type="text"
                      isAdmin={true}
                      onSave={handleSave}
                    />

                    <EditableField
                      field="infoPlataforma.usuario"
                      label="Usuario"
                      value={cliente.infoPlataforma?.usuario || ''}
                      type="text"
                      isAdmin={true}
                      onSave={handleSave}
                    />

                    <EditableField
                      field="infoPlataforma.contrasena"
                      label="Contraseña"
                      value={cliente.infoPlataforma?.contrasena || ''}
                      type="text"
                      isAdmin={true}
                      onSave={handleSave}
                    />

                    <EditableField
                      field="estadoClienteEspecial"
                      label="Estado cliente especial COTIZANDO, COTIZACION_PASADA //CONTACTO_CLIENTE //NO_ACCESO_PLATAFORMA COTIZACION_LISTA" 
                      value={cliente.estadoClienteEspecial || ''}
                      type="text"
                      isAdmin={true}
                      onSave={handleSave}
                    />

                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Información Adicional */}
          <div className="mt-8 pt-6 border-t border-gray-200">
            <div className="flex items-center gap-2 mb-6">
              <div className="w-1 h-6 bg-purple-500 rounded-full"></div>
              <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wide">
                Cuentas de cliente
              </h3>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-1 gap-6 pl-3">
              
              <AddCuentasCliente 
                onAgregarCuenta={handleAgregarCuenta}
                listaCuentas={cliente.cuentasClientes}
                onEliminarCuenta={eliminarCuenta}
              />


            </div>
          </div>
        </div>
        
      </div>

      <div className="max-w-7xl mx-auto px-6 py-6">
        
        {/* Estadísticas */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
          <StatCard 
            title="Total Servicios" 
            value={estadisticas.totalServicios}
            subtitle={`${estadisticas.serviciosCompletados} completados`}
            icon={CheckCircle}
            color="green"
          />
          <StatCard 
            title="Total Gastado" 
            value={`$${estadisticas.totalGastado.toLocaleString()}`}
            subtitle={`Promedio: $${estadisticas.promedioGasto.toLocaleString()}`}
            icon={DollarSign}
            color="blue"
          />
          <StatCard 
            title="Total Solicitudes" 
            value={estadisticas.totalSolicitudes}
            subtitle={`${estadisticas.solicitudesPendientes} pendientes`}
            icon={FileText}
            color="purple"
          />
          <StatCard 
            title="Ganancia Total" 
            value={`$${estadisticas.totalGanancia.toLocaleString()}`}
            subtitle={`Conversión: ${estadisticas.tasaConversion.toFixed(1)}%`}
            icon={TrendingUp}
            color="emerald"
          />
        </div>

        {/* Dos columnas */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          
          {/* Columna izquierda - Solicitudes */}
          <div>
            <div className="bg-white rounded-xl shadow-lg p-6">
              <div className="flex items-center justify-between mb-4">
                <h2 className="text-lg font-bold text-gray-900 flex items-center gap-2">
                  <FileText className="w-5 h-5 text-blue-600" />
                  Solicitudes ({solicitudesFiltradas.length})
                </h2>
              </div>
              
              {/* Filtros de solicitudes */}
              <div className="mb-4 space-y-3">
              
                <div className="relative">
                  <Search className="absolute left-3 top-3 w-4 h-4 text-gray-400" />
                  <input
                    type="text"
                    placeholder="Buscar solicitudes..."
                    value={searchSolicitudes}
                    onChange={(e) => setSearchSolicitudes(e.target.value)}
                    className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                  />
                </div>
              </div>

              {/* Lista de solicitudes */}
              <div className="max-h-96 overflow-y-auto">
                {solicitudesFiltradas.length === 0 ? (
                  <div className="text-center py-8">
                    <FileText className="w-12 h-12 text-gray-400 mx-auto mb-4" />
                    <p className="text-gray-500">No hay solicitudes</p>
                  </div>
                ) : (
                  solicitudesFiltradas.map((solicitud, index) => (
                    <CardSolicitud solicitud={solicitud}/>
                  ))
                )}
              </div>
            </div>
          </div>

          {/* Columna derecha - Servicios */}
          <div>
            <div className="bg-white rounded-xl shadow-lg p-6">
              <div className="flex items-center justify-between mb-4">
                <h2 className="text-lg font-bold text-gray-900 flex items-center gap-2">
                  <CheckCircle className="w-5 h-5 text-green-600" />
                  Servicios ({serviciosFiltrados.length})
                </h2>
              </div>
              
              {/* Filtros de servicios */}
              <div className="mb-4 space-y-3">
                
                <div className="relative">
                  <Search className="absolute left-3 top-3 w-4 h-4 text-gray-400" />
                  <input
                    type="text"
                    placeholder="Buscar servicios..."
                    value={searchServicios}
                    onChange={(e) => setSearchServicios(e.target.value)}
                    className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm"
                  />
                </div>
              </div>

              {/* Lista de servicios */}
              <div className="max-h-96 overflow-y-auto">
                {serviciosFiltrados.length === 0 ? (
                  <div className="text-center py-8">
                    <CheckCircle className="w-12 h-12 text-gray-400 mx-auto mb-4" />
                    <p className="text-gray-500">No hay servicios</p>
                  </div>
                ) : (
                  serviciosFiltrados.map((servicio, index) => (
                    <CardServicio servicio={servicio}/>
                    
                  ))
                  
                )}
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );

};

export default HistorialCliente;